// libs
import React from 'react';
// styles
import styles from './LoginLayout.module.scss';
// helpers
import { getCloudinaryUrl } from '@/helpers/cloudinary';
const imageId = 'v1695795325/Instamart_supply/KBA%20Login/Foreground.png';
const WIDTH = 375;
const HEIGHT = 500;
const LoginLayout = ({ children }) => {
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.heroImageContainer },
            React.createElement("img", { src: getCloudinaryUrl(imageId, {
                    width: WIDTH * 2,
                    height: HEIGHT * 2,
                }), className: styles.heroImage })),
        children));
};
export default LoginLayout;
